import axios from "axios";
const BASE_URL = process.env.REACT_APP_DEV_URL;

export const addMainCategory = async (token, data) => {
  const url = `${BASE_URL}/products/categorys-details/`;

  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (key === "image" && data[key] instanceof File) {
      formData.append(key, data[key], data[key].name);
    } else if (data[key] === null) {
      // Don't append data
    } else {
      // Append other data
      formData.append(key, data[key]);
    }
  });

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.post(url, formData, config);
    // // console.log(response);

    return response;
  } catch (error) {
    if (error.response.status === 502) {
      return error.response;
    } else if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.log(error);

      console.error(error);
      throw error;
    }
  }
};

export const getAllMainCategories = async (token) => {
  const url = `${BASE_URL}/products/categorys-details/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (error.response.status === 502) {
      console.log(error.response);
      return error.response;
    } else if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const getMainCategory = async (token, categoryId) => {
  const url = `${BASE_URL}/products/categorys-details/${categoryId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.get(url, config);
    return response;
  } catch (error) {
    if (error.response.status === 502) {
      console.log(error.response);
      return error.response;
    } else if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};

export const updateMainCategory = async (token, data, categoryId) => {
  const url = `${BASE_URL}/products/categorys-details/${categoryId}/`;

  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (key === "image" && data[key] instanceof File) {
      formData.append(key, data[key], data[key].name);
    } else if (data[key] === null) {
      // Don't append data
    } else {
      // Append other data
      formData.append(key, data[key]);
    }
  });

  const config = {
    headers: {
      Authorization: `Token ${token}`,
      "Content-Type": "multipart/form-data",
    },
  };

  try {
    const response = await axios.patch(url, formData, config);
    return response;
  } catch (error) {
    if (error.response.status === 502) {
      console.log(error.response);
      return error.response;
    } else if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Validation or Client Error:", error.response);
      return error.response;
    } else {
      console.error(error);
      throw error;
    }
  }
};

export const deleteMainCategory = async (token, categoryId) => {
  const url = `${BASE_URL}/products/categorys-details/${categoryId}/`;

  const config = {
    headers: {
      Authorization: `Token ${token}`,
    },
  };

  try {
    const response = await axios.delete(url, config);
    return response;
  } catch (error) {
    if (error.response.status === 502) {
      console.log(error.response);
      return error.response;
    } else if (
      error.response &&
      error.response.status >= 400 &&
      error.response.status < 500
    ) {
      console.log("Client Error:", error.response);
      return error.response;
    } else {
      console.error("Server or Network Error:", error);
      throw error;
    }
  }
};
